import React from 'react';

const HeartSvg = ({ goalRef }) => {
  return (
    <>
      <svg className="animation__svg heart--simple" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 17">
        <path d="M17.801 1.837c-3.705-3.51-7.8 1.56-7.8 1.56S5.905-1.48 2.2 1.837c-4.095 3.705.78 10.335 7.8 13.846 7.216-3.51 11.896-10.336 7.801-13.846Z" fill="#FFC399" stroke="#FB6B21" strokeWidth="1.047" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      <svg className="animation__svg heart" id="heart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 40">
        <path d="M43.565 4.23c-9.253-8.46-19.118 3.847-19.118 3.847S14.277-2.846 5.329 4.23c-5.276 4.154-4.511 11-.611 17.384C8.618 28 15.806 34.308 24.523 38.54 41.806 30.076 53.43 13.384 43.565 4.23Z" fill="#FFDFCA"/>
        <path d="M1.506 7.846s4.512.077 9.253 5.385c5.735 6.461 6.041 15.615 10.63 18.615 3.823 2.462 10.17 2.77 10.17 2.77l-6.653 3.922c-.077 0-22.788-10.23-23.4-30.692Z" fill="#FFC197"/>
        <path d="M43.565 4.23c-9.253-8.46-19.118 3.847-19.118 3.847S14.277-2.846 5.329 4.23c-5.276 4.154-4.511 11-.611 17.384C8.618 28 15.806 34.308 24.523 38.54 41.806 30.076 53.43 13.384 43.565 4.23Z" fill="none" stroke="#FF6B00" strokeWidth="2.16" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M37.523 6.077s3.671.692 5.2 5.384" stroke="#fff" strokeWidth="2.16" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </>
  );
};

export default HeartSvg;
